import React from "react";
import "./ExtratoFilters.css";

const ExtratoFilters = ({
  filters = {
    type: "ALL",
    status: "ALL",
    order: "",
    start: "",
    end: "",
  },
  onChange,
  onApply,
  onClear,
  loading,
}) => {
  return (
    <div className="filters-card">
      <div className="filters-header">
        <h3>Filtros do extrato</h3>
      </div>

      <div className="filters-grid">
        <div className="field">
          <label>Tipo de lançamento</label>
          <select
            value={filters.type}
            onChange={(e) => onChange({ type: e.target.value })}
          >
            <option value="ALL">Todos</option>
            <option value="CREDIT">Crédito</option>
            <option value="DEBIT">Débito</option>
          </select>
        </div>

        <div className="field">
          <label>Status</label>
          <select
            value={filters.status}
            onChange={(e) => onChange({ status: e.target.value })}
          >
            <option value="ALL">Todos</option>
            <option value="CONFIRMED">Confirmado</option>
            <option value="AWAITING_CONFIRMATION">Aguardando confirmação</option>
            <option value="WITHDRAW_REQUESTED">Saque solicitado</option>
            <option value="CANCELED">Cancelado</option>
          </select>
        </div>

        <div className="field">
          <label>Buscar por Nº da compra</label>
          <input
            placeholder="Ex: 1234"
            value={filters.order}
            onChange={(e) => onChange({ order: e.target.value })}
          />
        </div>

        <div className="field">
          <label>Período (opcional)</label>
          <div className="date-range">
            <input
              type="date"
              value={filters.start}
              onChange={(e) => onChange({ start: e.target.value })}
            />
            <input
              type="date"
              value={filters.end}
              onChange={(e) => onChange({ end: e.target.value })}
            />
          </div>
        </div>
      </div>

      <div className="filters-actions">
        <button className="btn-secondary" onClick={onClear} disabled={loading}>
          Limpar filtros
        </button>
        <button className="btn-primary" onClick={onApply} disabled={loading}>
          Aplicar filtros
        </button>
      </div>
    </div>
  );
};

export default ExtratoFilters;
